import React, { useEffect, useRef, useState } from 'react';
import { Marker } from "@react-google-maps/api";

import pin from "../../../src/images/listviewpage/map-pin.svg";
import pinHover from '../../../src/images/listviewpage/hover-map-pin.svg';

import './index.sass';


const MapMarker = ({ activePlaceId, clusterer, hoveredPlaceId, infoWindow, place }) => {

  const [hovered, setHovered] = useState(null);
  const markerRef = useRef();

  const { id, ids, lat, long } = place;
  const position = { lat, lng: long };
  const isActive = activePlaceId && activePlaceId === id;


  useEffect(() => {
    if (hoveredPlaceId && hoveredPlaceId === id) {
      !hovered && setHovered(true);
    } else {
      hovered && setHovered(false);
    }
  }, [hoveredPlaceId]);


  return (
    <Marker
      ref={markerRef}
      onMouseOver={() => setHovered(true)}
      onMouseOut={() => setHovered(false)}
      key={id}
      position={position}
      clusterer={clusterer}
      onClick={() => infoWindow.current.show(id, position, ids)}
      options={{ zIndex: hovered || isActive ? 1000 : null, metadata: { id }}}
      noClustererRedraw={true}
      icon={{
        url: hovered || isActive ? pinHover : pin,
        scaledSize: { width: 50, height: 50 },
        anchor: { x: 20, y: 45 },
      }}
    />
  )
};

export default MapMarker;
